import React, { FC, useState } from "react";
import clsx from "clsx";

import { FaqCategoryItem } from "../types";

import styles from "./FaqAccordion.module.scss";

type Props = {
  faqData: FaqCategoryItem;
};

const FaqAccordion: FC<Props> = ({ faqData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { question, Answer } = faqData;

  return (
    <div className={styles.accordion}>
      <button
        className={styles.button}
        type="button"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(prevIsOpen => !prevIsOpen)}
      >
        <span className={styles.group}>
          <span className={styles.icon}>
            <span>Q</span>
          </span>
          <span className={styles.question}>{question}</span>
        </span>
        <span className={clsx(styles.toggle, isOpen && styles.isOpen)} />
      </button>
      {isOpen && <Answer />}
    </div>
  );
};

export default FaqAccordion;
